import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { IField } from 'app/main/pages/settings/documenttype/document-type-settings-modal/document-type-settings.dto';
import { TranslocoRootModule } from 'app/transloco-root.module';
import { FieldActionEvent } from '../dynamic-field.component';

@Component({
  selector: 'app-bcc-settings-field',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoRootModule,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './bcc-settings-field.component.html',
  styleUrl: './bcc-settings-field.component.scss'
})
export class BccSettingsFieldComponent {
  @Input() formGroup!: FormGroup;
  @Output() actionEmit = new EventEmitter<FieldActionEvent>();
  @Input() canEdit: boolean = true;
  @Input()
  set field(value: IField) {
    this._field = structuredClone(value);
  }

  get field(): IField {
    return this._field;
  }


  public _field: IField;
  public bccRef: NgbModalRef;
  public submitted: boolean = false;


  constructor(private _modalService: NgbModal) {}



  bccModal(activateBCCModal) {
    this.bccRef = this._modalService.open(activateBCCModal, {
      windowClass: 'active-bcc-modal',
      backdrop: 'static'
    });
  }


  submitBcc(): void {
    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    this.submitted = false;
    this.bccRef.close();
  }


  onChangeActiveBcc(event: boolean): void {
    this.actionEmit.emit({ action: 'onChangeActiveBcc', data: event });
  }
}
